// Polish
export const pl = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portal klienta',
  'app.signOut':        'Wyloguj',

  'login.email':        'E-mail',
  'login.password':     'Hasło',
  'login.signIn':       'Zaloguj się',
  'login.signingIn':    'Logowanie…',
  'login.failed':       'Nie udało się zalogować',
  'login.newAccount':   'Nowy w Kardolive?',
  'login.createAccount':'Utwórz darmowe konto →',

  'nav.workspace':      'Obszar roboczy',
  'nav.templates':      'Szablony',
  'nav.live':           'Na żywo',
  'nav.rooms':          'Pokoje i czat',
  'nav.content':        'Treści',
  'nav.developer':      'Programista',
  'nav.account':        'Konto',

  'nav.overview':       'Przegląd',
  'nav.projects':       'Projekty',
  'nav.chat':           'Konsola czatu',
  'nav.sessions':       'Sesje',
  'nav.streams':        'Transmisje na żywo',
  'nav.studio':         'Studio',
  'nav.recordings':     'Nagrania',
  'nav.apiKeys':        'Klucze API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Tester webhooków',
  'nav.networkTest':    'Test sieci',
  'nav.embed':          'Widgety osadzone',
  'nav.sdk':            'SDK i dokumentacja',
  'nav.docs':           'Dokumentacja',
  'nav.analytics':      'Analityka',
  'nav.settings':       'Ustawienia',

  'overview.welcome':       'Witaj ponownie, {name}',
  'overview.plan':          '{tenant} · plan {plan}',
  'overview.newStream':     'Nowa transmisja',
  'overview.kpi.live':           'Na żywo',
  'overview.kpi.live.broadcasting': 'transmisji trwa',
  'overview.kpi.live.nothing':    'nic na żywo',
  'overview.kpi.total':           'Wszystkie transmisje',
  'overview.kpi.total.sub':       'wszech czasów',
  'overview.kpi.sessions':        'Sesje · 30 dni',
  'overview.kpi.sessions.sub':    'zdarzenia publikacji',
  'overview.kpi.recordings':      'Nagrania',
  'overview.kpi.recordings.sub':  'gotowe do odtwarzania',
  'overview.recentStreams':       'Ostatnie transmisje',
  'overview.recentSessions':      'Ostatnie sesje',
  'overview.viewAll':             'Zobacz wszystkie →',
  'overview.empty.title':         'Jeszcze brak transmisji',
  'overview.empty.body':          'Utwórz swoją pierwszą transmisję, aby rozpocząć nadawanie.',
  'overview.empty.action':        'Utwórz transmisję',
  'overview.noSessions':          'Brak sesji',

  'status.live':        'NA ŻYWO',
  'status.idle':        'BEZCZYNNY',
  'status.ended':       'ZAKOŃCZONY',
  'status.archived':    'ZARCHIWIZOWANY',

  'common.save':        'Zapisz',
  'common.cancel':      'Anuluj',
  'common.delete':      'Usuń',
  'common.edit':        'Edytuj',
  'common.create':      'Utwórz',
  'common.confirm':     'Potwierdź',
  'common.loading':     'Ładowanie…',
  'common.error':       'Błąd',
  'common.retry':       'Ponów',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Przejdź do treści strony",
  "nav.streamTemplates": "Szablony transmisji",
  "nav.boards": "Tablice interaktywne",
  "nav.menu": "Otwórz nawigację",
  "nav.closeMenu": "Zamknij nawigację",
  "nav.scenarios": "Scenariusze",
  "nav.premieres": "Premiery",
  "nav.clips": "Klipy",
  "dashboard.account": "Konto",
  "dashboard.language": "Język",
  "dashboard.appearance": "Wygląd",
  "nav.allStreams": "Wszystkie transmisje",
  "nav.destinations": "Miejsca docelowe",
  "nav.ecommerce": "Handel elektroniczny",
  "nav.products": "Produkty",
  "nav.services": "Usługi",
  "nav.collections": "Kolekcje",
  "nav.orders": "Zamówienia",
  "nav.commerceSettings": "Ustawienia handlu",
  "nav.engagement": "Interakcje",
  "theme.light": "Przełącz na tryb jasny",
  "theme.dark": "Przełącz na tryb ciemny",
  "role.owner": "Właściciel",
  "role.admin": "Administrator",
  "role.member": "Członek",
  "role.viewer": "Obserwator",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Aktywne",
  "streams.archived": "Zarchiwizowane",
  "streams.monitor": "Monitor sygnałów",
  "streams.create": "Utwórz transmisję na żywo",
  "streams.list": "Lista",
  "streams.grid": "Siatka",
  "streams.view": "Widok transmisji",
  "streams.searchLabel": "Szukaj wydarzeń",
  "streams.searchHint": "Szukaj według nazwy",
  "streams.solutionFilter": "Filtruj wydarzenia według typu",
  "streams.statusFilter": "Filtruj wydarzenia według statusu",
  "streams.dateFilter": "Filtruj według daty utworzenia",
  "streams.allSolutions": "Wszystkie typy",
  "streams.custom": "Istniejąca lub własna konfiguracja",
  "streams.allStatuses": "Wszystkie statusy",
  "streams.anyTime": "Dowolna data utworzenia",
  "streams.last7": "Utworzone w ostatnich 7 dniach",
  "streams.last30": "Utworzone w ostatnich 30 dniach",
  "streams.count": "Wyświetlane wydarzenia: {shown} z {total}",
  "streams.noMatch": "Żadne wydarzenie nie pasuje do filtrów.",
  "streams.clearFilters": "Wyczyść filtry",
  "streams.refreshFailed": "Nie udało się odświeżyć listy",
  "streams.loadFailed": "Nie udało się wczytać transmisji",
  "streams.stale": "Wyświetlono ostatnio wczytaną listę. Statusy mogły się zmienić.",
  "streams.connectionHint": "Sprawdź połączenie i ponownie wczytaj listę.",
  "streams.retrying": "Ponawianie…",
  "streams.retry": "Spróbuj ponownie",
  "streams.restoreFailed": "Nie udało się przywrócić transmisji",
  "streams.restoreHint": "Sprawdź połączenie i odśwież listę, aby potwierdzić status przed kolejną próbą.",
  "streams.unused": "Nieużywane transmisje: {count}",
  "streams.unusedHint": "Brak emisji i powtórek. Zarchiwizuj je, aby uporządkować listę; nic nie zostanie usunięte.",
  "streams.reviewArchive": "Sprawdź i zarchiwizuj",
  "streams.loading": "Wczytywanie transmisji…",
  "streams.archiveEmpty": "Archiwum jest puste. Zarchiwizowane transmisje i ich powtórki pozostają tutaj do czasu przywrócenia.",
  "streams.restore": "Przywróć",
  "streams.firstTitle": "Utwórz pierwszą transmisję",
  "streams.firstBody": "Wybierz konfigurację dla sprzedaży, zajęć lub usług albo zacznij od pustej transmisji. Nadawaj z przeglądarki, telefonu lub OBS.",
  "streams.blank": "Pusta transmisja",
  "streams.broadcasts": "Emisje: {count}",
  "streams.replays": "Powtórki: {count}",
  "streams.sessions": "Sesje: {count}",
  "streams.recordings": "Nagrania: {count}",
  "streams.mode.BROADCAST": "Transmisja",
  "streams.mode.LOW_LATENCY": "Niskie opóźnienie",
  "streams.mode.REALTIME": "Czas rzeczywisty",
  "streams.key": "Klucz",
  "streams.archiveTitle": "Archiwizuj nieużywane transmisje",
  "streams.archiveHint": "Te transmisje nigdy nie były nadawane. Możesz je przywrócić w dowolnej chwili w zakładce Zarchiwizowane.",
  "streams.archiveFailed": "Nie udało się zarchiwizować {count} transmisji; mogły rozpocząć nadawanie. Pozostałe zarchiwizowano.",
  "streams.archiving": "Archiwizowanie…",
  "streams.archiveCount": "Archiwizuj: {count}",
  "streamType.webinar": "Webinary biznesowe i premiery",
  "streamType.classroom": "Lekcje i korepetycje",
  "streamType.training": "Szkolenia firmowe",
  "streamType.conference": "Konferencje i wystawy",
  "streamType.shopping": "Zakupy na żywo",
  "streamType.auction": "Aukcje na żywo",
  "streamType.consultation": "Prywatne konsultacje",
  "streamType.creator": "Transmisje twórców i społeczności",
  "streamType.audio": "Pokoje audio i podcasty",
  "streamType.sports": "Sport i esport",
  "streamType.performance": "Koncerty i występy",
  "streamType.community": "Nabożeństwa i zbiórki",
  "streamType.tour": "Wycieczki i prezentacje",
  "streamType.fitness": "Fitness i warsztaty",
  "streamType.public-meeting": "Wiadomości i spotkania publiczne",
  "streamType.continuous": "Kanały ciągłe i kamery",
  "streams.close": "Zamknij",
};
